import React from "react";

const HeroCareer = () => {
  return (
    <section className="career-section">

      <div className="career-hero-content text-center">
        <h1>Let’s drive the Automotive Aftermarket!</h1>
        <div>
          <div style={{ marginTop: '300px' }}>
            <a href="#B2B" style={{ textDecoration: 'none', }} className="text-light hiring-btn" >Job Openings</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroCareer;
